import { schemaTypes, dateFormat } from "../../../constants/constants";

const schema = {
  key: "utilization_report",
  name: "Utilization Report",
  toolbar: [],
  content: [
    {
      key: "utilization_report",
      name: "Utilization Report",
      type: schemaTypes.UTILIZATION_REPORT,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};
export default schema;

